import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-92" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-93" data-mp="32num8qaq072f">
        <p className="text-xl font-black uppercase tracking-tight text-stone-900" data-id="element-94" data-mp="32pffmclatjyp">
          Hospitality English Ready™
        </p>
        <nav aria-label="Footer" data-id="element-95" data-mp="36n3bpiyq9is6">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-stone-500" data-id="element-96" data-mp="3uesbfkdvp9j5">
            {links.map(link => <li key={link} data-id="element-97" data-mp="36d2kv7umpm9">
                <a href="#offer" className="transition-colors hover:text-red-500" data-id="element-98" data-mp="3levkfc40nykx">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-stone-400" data-id="element-99" data-mp="29zgjxyclmol2">
          © 2026 Hospitality English Ready™. All rights reserved.
        </p>
      </div>
    </footer>;
}